export default __webpack_public_path__ + "locales/si/DownloadDialog.json?hash=3ade84b5f8206eb205ba43f5de1b8c51";